import React from 'react';
import { FadeInUp } from './FadeInUp';
const steps = [{
  day: 'Día 1',
  title: 'La Primera Sesión',
  description: 'Descubrirás cómo 7 minutos de trabajo olfativo estructurado cansan la mente de tu perro más que una hora de paseo físico.'
}, {
  day: 'Día 7',
  title: 'Cambios Visibles',
  description: 'Notarás que tu perro comienza a elegir el descanso por sí mismo. Los ladridos reactivos disminuyen drásticamente.'
}, {
  day: 'Para Siempre',
  title: 'Calma Duradera',
  description: 'Has reprogramado la respuesta al estrés de tu perro. Ahora tienes un compañero equilibrado y feliz en casa.'
}];
export function MethodSection() {
  return <section className="py-20 px-5 max-w-4xl mx-auto pt-[10px] pb-[10px] space-y-[38px]" data-id="element-63">
      <div className="text-center mb-16" data-id="element-64">
        <FadeInUp data-id="element-65">
          <span className="inline-block text-pistachio font-bold tracking-wider text-sm mb-4" data-id="element-66">
            EL MÉTODO
          </span>
        </FadeInUp>
        <FadeInUp delay={0.1} data-id="element-67">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-slate-dark mb-6" data-id="element-68">
            Estimulación Cognitiva vs. Cansancio Físico
          </h2>
        </FadeInUp>
        <FadeInUp delay={0.2} data-id="element-69">
          <p className="text-lg text-slate-dark/80 max-w-2xl mx-auto" data-id="element-70">
            Muchos dueños creen que la solución a la ansiedad es correr hasta el
            agotamiento. La ciencia demuestra que el trabajo mental enfocado
            reduce los niveles de cortisol mucho más rápido.
          </p>
        </FadeInUp>
      </div>

      <div className="relative border-l-2 border-zen-beige ml-4 md:ml-8 space-y-12 pb-8" data-id="element-71">
        {steps.map((step, index) => <FadeInUp key={index} delay={index * 0.15} className="relative pl-8 md:pl-12" data-id="element-72">
            <div className="absolute -left-[17px] top-1 w-8 h-8 rounded-full bg-pistachio border-4 border-white flex items-center justify-center shadow-sm" data-id="element-73">
              <div className="w-2 h-2 rounded-full bg-slate-dark" data-id="element-74" />
            </div>
            <div className="bg-white border border-zen-beige p-6 rounded-3xl shadow-sm" data-id="element-75">
              <span className="text-sm font-bold text-slate-dark/50 uppercase tracking-wider mb-2 block" data-id="element-76">
                {step.day}
              </span>
              <h3 className="text-xl font-bold text-slate-dark mb-3" data-id="element-77">
                {step.title}
              </h3>
              <p className="text-slate-dark/70 leading-relaxed" data-id="element-78">
                {step.description}
              </p>
            </div>
          </FadeInUp>)}
      </div>
    </section>;
}